<div class="share-app">
  <app-share-header
    [breadcrumb]="headerBreadcrumb"
    [user]="user"
    [asset_type]="assetName.video"
    [share_id]="shareIdInput"
    [asset_id]="assetId"
    [video_id]="videoId"
    [hideCommentsToggle]="true"
  ></app-share-header>

  <div class="share-body">
    <section class="player-section">
      <app-multi-video-player
        [videoUrls]="activeUrls"
        [voTracks]="voTracks"
        [bgmTrack]="bgmTrack"
        [defaultDuckTo]="0.2"
      ></app-multi-video-player>
    </section>

    <section class="vo-section">
      <div class="vo-row">
        <label for="bgm-input">Background music (JSON)</label>
        <button class="btn primary" (click)="applyBgm()">Apply BGM</button>
        <button class="btn ghost" (click)="clearBgm()">Clear</button>
      </div>
      <textarea
        id="bgm-input"
        [(ngModel)]="bgmInputText"
        rows="4"
        placeholder='{
  "url": "https://example.com/bgm.mp3",
  "volume": 0.3,
  "loop": true,
  "duckedByVoTo": 0.1
}'
      ></textarea>
      @if (bgmError) {
        <div class="status error">{{ bgmError }}</div>
      } @else if (bgmTrack) {
        <div class="status ok">
          BGM applied — base {{ (bgmTrack.volume ?? 0.3) }} / ducks to
          {{ (bgmTrack.duckedByVoTo ?? 0.1) }} under VO.
        </div>
      }
    </section>

    <section class="vo-section">
      <div class="vo-row">
        <label for="vo-input">VO tracks (JSON)</label>
        <button class="btn primary" (click)="applyVoTracks()">Apply VO</button>
        <button class="btn ghost" (click)="clearVoTracks()">Clear</button>
      </div>
      <textarea
        id="vo-input"
        [(ngModel)]="voInputText"
        rows="6"
        placeholder='[
  { "url": "https://example.com/vo1.mp3", "startTime": 0, "duration": 8 },
  { "url": "https://example.com/vo2.mp3", "startTime": 10, "duckVideoTo": 0.2 }
]'
      ></textarea>
      @if (voError) {
        <div class="status error">{{ voError }}</div>
      } @else if (voTracks.length) {
        <div class="status ok">
          {{ voTracks.length }} VO track{{ voTracks.length === 1 ? "" : "s" }} applied.
        </div>
      }
    </section>

    <section class="load-section" style="display: none;">
      <div class="load-row">
        <label for="share-id-input">Share ID</label>
        <input
          id="share-id-input"
          type="text"
          [(ngModel)]="shareIdInput"
          (keydown.enter)="loadFromShare()"
          placeholder="Paste share ID..."
        />
        <button
          class="btn primary"
          (click)="loadFromShare()"
          [disabled]="loading"
        >
          {{ loading ? "Loading..." : "Load approved videos" }}
        </button>
      </div>

      @if (error) {
        <div class="status error">{{ error }}</div>
      } @else if (activeUrls.length) {
        <div class="status ok">
          Loaded {{ approvedShots }} approved video{{ approvedShots === 1 ? "" : "s" }}
          from {{ totalShots }} total shot{{ totalShots === 1 ? "" : "s" }}.
        </div>
      }
    </section>
  </div>
</div>
